<template>
    <div class="step-content">
        <div class="row no-gutters justify-content-start align-items-center common-step-head">
            <img
                src="../assets/images/step_icon.png"
                alt="step"
            />
            <p>{{$t('stepOne.title')}}</p>
        </div>
        <div class="progress custom-progress">
            <div
                class="progress-bar"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <!-- 商品 & 问卷表单 begin -->
        <div class="row justify-content-between no-gutters common-step-padding">
            <div class="col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div class="goods-info">
                    <img
                        :src="$store.state.giftImage"
                        :alt="$store.state.giftName"
                    />
                    <div class="good-info-mask step-good-mask good-mask-one-row">
                        <span>{{$store.state.giftName}}</span>
                    </div>
                </div>
            </div>
            <!-- 问卷表单 begin -->
            <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                <div class="left-form-distance common-form-margin">
                    <form action="">
                        <div
                            class="question-form"
                            v-for="(item,index) in $t('stepOne.questionList')"
                            :key="index"
                        >
                            <!-- 单选 -->
                            <div
                                class="question-group"
                                v-if="item.select_type == 'radio'"
                            >
                                <div class="ask">{{item.title}}</div>
                                <div
                                    class="form-check form-check-inline"
                                    v-for="(items,idx) in item.option"
                                    :key="idx"
                                >
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        :name="item.name"
                                        :id="item.name+items.value"
                                        :value="items.value"
                                        :checked="items.value===$store.state.stepOne[item.name]"
                                        @change="onChangeItem($event,item.name,items.value)"
                                    />
                                    <label
                                        class="form-check-label"
                                        :for="item.name+items.value"
                                    >
                                        {{items.txt}}
                                    </label>
                                    <input
                                        class="ml-2"
                                        v-if="item.name==='reason'&&items.value===5"
                                        type="text"
                                        v-model="$store.state.stepOne.otherReason"
                                        ref="reason"
                                        :placeholder="items.placeholder"
                                        :disabled="$store.state.stepOne.isDisabledInput"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters btn-justify-content-end btn-justify-content-center">
                            <button
                                type="submit"
                                class="common-comfirm-btn btn-width-100"
                                @click="goNext"
                                :disabled="$store.state.stepOne.isDisabledBtnNext"
                            >
                                {{$t('stepOne.btnNext')}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <!-- 问卷表单 end -->
        </div>
        <!-- 商品 & 问卷表单 end -->
    </div>
</template>

<script>

export default {
    name: 'StepOne',
    data() {
        return {
        }

    },
    components: {

    },
    methods: {
        // 问卷填写
        onChangeItem(e, name, value) {
            switch (name) {
                case `${name}`:
                    this.$store.state.stepOne[name] = value
                    break
            }
            if (name === 'reason' && value === 5) { // 选择其它原因
                this.$store.state.stepOne.isDisabledInput = false // 输入框可输入
                this.$refs['reason'][0].focus() // 输入框获取焦点
            } else {
                this.$store.state.stepOne.isDisabledInput = true
                this.$store.state.stepOne.otherReason = '' // 清空其它原因输入
            }
            this.updateBtnStatus()
        },
        // 更新下一步按钮状态
        updateBtnStatus() {
            let sex = this.$store.state.stepOne.sex
            let age = this.$store.state.stepOne.age
            let reason = this.$store.state.stepOne.reason
            let isDisabledBtnNext = false

            if (sex !== null && age !== null && reason !== null) {
                isDisabledBtnNext = false
            } else {
                isDisabledBtnNext = true
            }

            this.$store.state.stepOne.isDisabledBtnNext = isDisabledBtnNext
        },
        // 下一步
        goNext() {
            if (!this.$store.state.stepOne.isDisabledBtnNext) {
                this.$router.push({ path: '/stepTwo' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.question-group {
    margin-bottom: 30px;
}
.question-group .ask {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
}
.form-check-inline {
    margin-right: 50px;
}
.question-group .form-check-inline:last-child {
    margin: 0;
}
.form-check-inline,
.form-check-inline input,
.form-check-inline label {
    cursor: pointer;
}
input {
    width: 410px;
    padding: 5px 10px;
    font-size: 14px;
    background: #f7f7f7;
    outline: none;
    box-shadow: none;
    border: none;
}
@media only screen and (min-width: 320px) and (max-width: 1023px) {
    input {
        width: 200px;
    }
}
</style>